import React from 'react'
import { Card, CardBody, } from 'reactstrap'
import { BeatLoader } from 'react-spinners'

export default function CardLoading () {
  return (
    <Card>
      <CardBody>
        <BeatLoader loading={true}/>
      </CardBody>
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDash/CardLoading.js